(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle,
	bodyScrollLock, ajaxPostLoad */

	// window.matchMedia("(max-width: 700px)")
	const documentBodyStyle = getComputedStyle(document.body);
	const lgBreakpoint = documentBodyStyle.getPropertyValue("--lg-breakpoint");

	const panelTransitionTime = 1500;
	const locationOrigin = window.location.origin;

	let lazyLoadInstance;
	let scrollbarWidth;
	let horizontalScrollbarWidth;
	let windowWidth;
	let scrollTransform = 0;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".js-lazy",
			threshold: 500,
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);

		horizontalScrollbarWidth = $(".js-scrollbar-tester").get(0).scrollHeight - $(".js-scrollbar-tester").get(0).clientHeight;
		document.documentElement.style.setProperty("--horizontal-scrollbar", `${horizontalScrollbarWidth}px`);
	}





// Follow Cursor
// -----------------------------------------------------------------------------

	function bindMouse() {
		$(document).bind("mousemove", (e) => {
			$(".js-cursor").css({
				left: e.clientX,
				top: e.clientY,
			});
		});
	}





// Cursor States
// -----------------------------------------------------------------------------

	function resetCursorStates() {
		$(".js-cursor-content").html("");
		$(".js-cursor-text").css("width", "");
		$(".js-cursor-text").removeClass("is-active");
	}

	function cursorStates() {
		$(".js-cursor-link").mouseenter((e) => {
			$(".js-cursor-content").html($(e.currentTarget).data("text"));
			const contentWidth = $(".js-cursor-content").outerWidth();
			const textPadding = $(".js-cursor-text").css("padding-left");
			$(".js-cursor-text").css("width", `${contentWidth + parseInt(textPadding, 10) * 2}px`);
			$(".js-cursor-text").addClass("is-active");
		});

		$(".js-cursor-link").mouseleave(() => {
			resetCursorStates();
		});
	}





// Captions
// -----------------------------------------------------------------------------

	function initCaptions() {
		$(".js-caption").off("mouseenter, mouseleave");

		$(".js-caption").mouseenter((e) => {
			const contentWidth = $(e.currentTarget).find(".js-caption-content").outerWidth();
			const contentHeight = $(e.currentTarget).find(".js-caption-content").outerHeight();
			const contentMargin = $(e.currentTarget).find(".js-caption-content").css("margin-bottom");
			const plusHeight = $(e.currentTarget).find(".js-caption-plus").outerHeight();
			$(e.currentTarget).find(".js-caption-toggle").css("width", `${contentWidth}px`);
			$(e.currentTarget).find(".js-caption-toggle").css("height", `${contentHeight + plusHeight + parseInt(contentMargin, 10)}px`);
			$(e.currentTarget).addClass("is-active");
		});

		$(".js-caption").mouseleave((e) => {
			$(e.currentTarget).find(".js-caption-toggle").css("width", "");
			$(e.currentTarget).find(".js-caption-toggle").css("height", "");
			$(e.currentTarget).removeClass("is-active");
		});
	}





// Horizontal Scroll
// -----------------------------------------------------------------------------

	const movePage = (scrollValue) => {
		const scrollWidth = $(".c-single-content__images").outerWidth() - windowWidth;
		scrollTransform += scrollValue;
		scrollTransform = scrollTransform > 0 ? 0 : scrollTransform;
		scrollTransform = scrollTransform < -scrollWidth ? -scrollWidth : scrollTransform;
		$(".js-images-wrapper").scrollLeft(-scrollTransform);
		if (scrollTransform < 0) {
			$(".js-scroll-label").addClass("is-hidden");
		}
	};

	const movePageOnKeydown = (event) => {
		let scrollValue = 0;
		if (event.keyCode === 40 || event.keyCode === 39) {
			scrollValue += -30;
		} else if (event.keyCode === 38 || event.keyCode === 37) {
			scrollValue += 30;
		}
		movePage(scrollValue);
	};

	function horinzontalScroll() {
		$(".js-single-container").off("mousewheel");
		document.removeEventListener("keydown", movePageOnKeydown);
		if (window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
			$(".js-single-container").on("mousewheel", (event) => {
				event.preventDefault();
				let scrollValue = event.deltaY;
				scrollValue += -event.deltaX;
				movePage(scrollValue);
			});
			document.addEventListener("keydown", movePageOnKeydown);
		}
	}





// Generate Page Title
// -----------------------------------------------------------------------------

	function generatePageTitle(page) {
		const pageTitle = $("<textarea />").html(page).text();
		return `Lucy Andrews | ${pageTitle}`;
	}





// Add Scroll Label
// -----------------------------------------------------------------------------

	function addScrollLabel() {
		const singleImage = $(".js-content-block img, .js-content-block video");
		const pageMargin = parseInt($(".js-images-inside").css("padding-left"), 10);
		let singleImageWidth = $(".js-single-description").outerWidth() + parseInt($(".js-single-description").css("margin-right"), 10) + pageMargin * 2;
		singleImage.each(function () {
			singleImageWidth += $(this).outerWidth() + pageMargin;
		});
		const contentWidth = singleImageWidth;
		const wrapperWidth = $(".js-images-wrapper").outerWidth();

		if (contentWidth > wrapperWidth) {
			$(".js-single-content").append("<div class='c-single-content__scroll-label js-scroll-label'>Scroll</div>");
		}
	}

	function removeScrollLabel() {
		$(".js-scroll-label").remove();
	}





// Set Project Header Height
// -----------------------------------------------------------------------------

	function setProjectHeaderHeight() {
		const singleHeaderHeight = $(".js-single-header").outerHeight();
		document.documentElement.style.setProperty("--single-header-height", `${singleHeaderHeight}px`);
	}





// Compensate for Single Container Scrollbar
// -----------------------------------------------------------------------------

	function compensateSingleScrollbar() {
		const panelScrollbar = $(".js-single-container").outerWidth() - $(".js-single-content").outerWidth();
		if (panelScrollbar > 0) {
			$(".js-close-panel-wrapper").css("margin-right", `${panelScrollbar}px`);
		} else {
			$(".js-close-panel-wrapper").css("margin-right", 0);
		}
	}





// Compensate for Scrollbar Activate / Deactivate
// -----------------------------------------------------------------------------

	function lockBody() {
		const targetElement = $(".js-single-inside").get(0);
		bodyScrollLock.disableBodyScroll(targetElement, { reserveScrollBarGap: true });
	}

	function unlockBody() {
		bodyScrollLock.clearAllBodyScrollLocks();
	}

	function compensateScrollbar() {
		scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		if (scrollbarWidth > 0) {
			document.documentElement.style.setProperty("--compensate-scrollbar", `${scrollbarWidth}px`);
		}
	}

	function decompensateScrollbar() {
		document.documentElement.style.setProperty("--compensate-scrollbar", "0");
	}

	function compensateOnSingleLoad() {
		if ($("html").hasClass("panel-is-open")) {
			scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
			if (scrollbarWidth > 0) {
				document.documentElement.style.setProperty("--compensate-scrollbar", `${scrollbarWidth}px`);
			}
			lockBody();
			setProjectHeaderHeight();
			addScrollLabel();
		}
	}





// Open / Close Panel Functions
// -----------------------------------------------------------------------------

	function closePanel() {
		$("html").removeClass("panel-is-open");
		setTimeout(() => {
			decompensateScrollbar();
			unlockBody();
			removeScrollLabel();
		}, panelTransitionTime);
	}

	function closePanelPushState() {
		closePanel();
		const homeURL = $("body").data("home");
		window.history.pushState("Work", generatePageTitle("Work"), homeURL);
		document.title = generatePageTitle("Work");
	}

	function openPanel() {
		// Compensate for scrollbar
		compensateScrollbar();

		// Init Captions Hover
		initCaptions();

		// Open Panel
		$(".js-single-inside").animate({ scrollTop: (0) }, 0);
		$("html").addClass("panel-is-open");

		addScrollLabel();

		setTimeout(() => {
			$("html").removeClass("page-is-loading");
		}, panelTransitionTime);

		// Lock Body
		lockBody();
	}

	function popStateListener(event) {
		if (event.state === "Work") {
			closePanel();
		} else if ((event.state === $(".js-single-container").attr("data-post")) && !$("html").hasClass("panel-is-open")) {
			openPanel();
		}
	}





// Close Single Panel on Click
// -----------------------------------------------------------------------------

	function closePanelOnClick() {
		$(document).on("click", ".js-close-panel, .js-single-overlay", (event) => {
			event.preventDefault();
			closePanelPushState();
		});
	}





// AJAX Single Page
// -----------------------------------------------------------------------------

	function ajaxSinglePage() {
		$(".js-single-link").click(function (event) {
			event.preventDefault();
			const postID = $(this).attr("data-link");
			const postLink = $(this).attr("href");
			$.ajax({
				url: ajaxPostLoad.ajaxurl,
				type: "post",
				data: {
					action: "ajax_post_load",
					post_id: postID,
				},
				beforeSend: () => {
					$("html").addClass("page-is-loading");
					resetCursorStates();
					scrollTransform = 0;
				},
				success: (result) => {
					// Parse content and add to wrapper
					const parsedResult = JSON.parse(result);
					$(".js-single-content").html(parsedResult.result);
					lazyLoadInstance.update();
					$(".js-single-container").attr("data-post", postID);
					setProjectHeaderHeight();

					// Add margin if scrollbar in wrapper
					compensateSingleScrollbar();

					// Open panel and change url
					openPanel();
					const newPageTitle = generatePageTitle(parsedResult.pageTitle);
					const newPageURL = parsedResult.url;
					const newPagePath = newPageURL.replace(locationOrigin, "");
					window.history.pushState(postID, newPageTitle, newPagePath);
					document.title = newPageTitle;

					// On Escape
					$(document).keyup((e) => {
						if (e.key === "Escape") {
							closePanelPushState();
						}
					});

					// On previous or next - doesn't work when viewing multiple projects
					window.removeEventListener("popstate", popStateListener);
					window.addEventListener("popstate", popStateListener);

				},
				error: () => {
					window.location.href = postLink;
				},
			});
		});
	}





// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		windowWidth = window.innerWidth;
		initLazyLoad();
		setScrollbarWidthVariable();
		ajaxSinglePage();
		compensateOnSingleLoad();
		closePanelOnClick();
		bindMouse();
		cursorStates();
		horinzontalScroll();
		initCaptions();
		window.addEventListener("popstate", popStateListener);
	});

	$(window).on("resize", () => {
		windowWidth = window.innerWidth;
		setScrollbarWidthVariable();
		horinzontalScroll();
	});

}(jQuery));
